import React from 'react';

export default function StatCard({ title, value, sub, icon: Icon, color = '#2D5BE3', trend }) {
  return (
    <div className="bg-[#1A2235] border border-[#1E2D45] rounded-2xl p-5">
      <div className="flex items-start justify-between mb-4">
        <div
          className="w-11 h-11 rounded-xl flex items-center justify-center"
          style={{ background: `${color}20`, border: `1px solid ${color}40` }}
        >
          <Icon size={20} style={{ color }} />
        </div>
        {trend !== undefined && (
          <span className={`text-xs font-semibold px-2 py-1 rounded-full
            ${trend >= 0 ? 'bg-green-500/10 text-green-400' : 'bg-red-500/10 text-red-400'}`}>
            {trend >= 0 ? '+' : ''}{trend}%
          </span>
        )}
      </div>
      <div className="text-2xl font-bold text-white mb-1">{value}</div>
      <div className="text-sm text-[#546E7A]">{title}</div>
      {sub && <div className="text-xs text-[#B0BEC5] mt-1">{sub}</div>}
    </div>
  );
}
